import UserActionTypes from './auth.types';

export const ROLES = {
  ADMIN: 'ADMIN',
  CLIENT: 'CLIENT'
};

export const changeEmailStart = (user) => ({
  type: UserActionTypes.CHANGE_EMAIL_START,
  payload: user
});

export const changeEmailSuccess = (user) => ({
  type: UserActionTypes.CHANGE_EMAIL_SUCCESS,
  payload: user
});

export const changeEmailFailure = (error) => ({
  type: UserActionTypes.CHANGE_EMAIL_FAILURE,
  payload: error
});



export const checkEmailStart = (user) => ({
  type: UserActionTypes.CHECK_EMAIL_START,
  payload: user
});

export const checkEmailSuccess = (user) => ({
  type: UserActionTypes.CHECK_EMAIL_SUCCESS,
  payload: user
});

export const checkEmailFailure = (error) => ({
  type: UserActionTypes.CHECK_EMAIL_FAILURE,
  payload: error
});

export const confirmPasswordStart = (user) => ({
  type: UserActionTypes.CONFIRM_PASSWORD_START,
  payload: user
});

export const confirmPasswordSuccess = (user) => ({
  type: UserActionTypes.CONFIRM_PASSWORD_SUCCESS,
  payload: user
});

export const confirmPasswordFailure = (error) => ({
  type: UserActionTypes.CONFIRM_PASSWORD_FAILURE,
  payload: error
});



export const changePasswordStart = (user) => ({
  type: UserActionTypes.CHANGE_PASSWORD_START,
  payload: user
});

export const changePasswordSuccess = (user) => ({
  type: UserActionTypes.CHANGE_PASSWORD_SUCCESS,
  payload: user
});

export const changePasswordFailure = (error) => ({
  type: UserActionTypes.CHANGE_PASSWORD_FAILURE,
  payload: error
});


export const signInStart = (user) => ({
  type: UserActionTypes.SIGN_IN_START,
  payload: user
});

export const signInSuccess = (user) => ({
  type: UserActionTypes.SIGN_IN_SUCCESS,
  payload: user
});

export const signInFailure = (error) => ({
  type: UserActionTypes.SIGN_IN_FAILURE,
  payload: error
});

export const signOutStart = (user) => ({
  type: UserActionTypes.SIGN_OUT_START,
  payload: user
});

export const signOutSuccess = () => ({
  type: UserActionTypes.SIGN_OUT_SUCCESS
});

export const signOutFailure = (error) => ({
  type: UserActionTypes.SIGN_OUT_FAILURE,
  payload: error
});

export const signUpStart = (user) => ({
  type: UserActionTypes.SIGN_UP_START,
  payload: user
});

export const signUpSuccess = (user) => ({
  type: UserActionTypes.SIGN_UP_SUCCESS,
  payload: user
});

export const signUpFailure = (error) => ({
  type: UserActionTypes.SIGN_UP_FAILURE,
  payload: error
});

export const confirmStart = (user) => ({
  type: UserActionTypes.COMFIRM_START,
  payload: user
});

export const confirmSuccess = (user) => ({
  type: UserActionTypes.COMFIRM_SUCCESS,
  payload: user
});

export const confirmFailure = (error) => ({
  type: UserActionTypes.COMFIRM_FAILURE,
  payload: error
});

export const signInSocialStart = (provider) => ({
  type: UserActionTypes.SIGN_IN_SOCIAL_START,
  payload: provider
});

export const signInSocialSuccess = (user) => ({
  type: UserActionTypes.SIGN_IN_SOCIAL_SUCCESS,
  payload: user
});

export const signInSocialFailure = (error) => ({
  type: UserActionTypes.SIGN_IN_SOCIAL_FAILURE,
  payload: error
});

export const setProfileStart = (user) => ({
  type: UserActionTypes.PROFILE_SET_START,
  payload: user
});

export const setProfileSuccess = (user) => ({
  type: UserActionTypes.PROFILE_SET_SUCCESS,
  payload: user
});

export const setProfileFailure = (error) => ({
  type: UserActionTypes.PROFILE_SET_FAILURE,
  payload: error
});
